import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { UI_MENU_CONTEXT } from './ui-menu-context.token';

/**
 * Content-projection menu row: consumers project arbitrary content (dots,
 * badges, trailing labels) while the component provides the menu behaviors
 * (role, keyboard activation, disabled state, hover variants, auto-close).
 */
@Component({
  selector: 'ui-menu-item-custom',
  standalone: true,
  template: `<ng-content />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'menuitem',
    tabindex: '0',
    class:
      'flex items-center gap-2 px-3 py-2 rounded cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-700',
    '[class.opacity-50]': 'disabled()',
    '[class.pointer-events-none]': 'disabled()',
    '[attr.aria-disabled]': 'disabled()',
    '[class.hover:bg-red-50]': 'danger()',
    '[class.dark:hover:bg-red-950]': 'danger()',
    '[class.hover:bg-amber-50]': 'warning()',
    '[class.dark:hover:bg-amber-950]': 'warning()',
    '[attr.title]': 'tooltip()',
    '(click)': 'activate()',
    '(keydown)': 'onKeydown($event)',
  },
})
export class UiMenuItemCustomComponent {
  tooltip = input<string | undefined>(undefined);
  disabled = input<boolean>(false);
  danger = input<boolean>(false);
  warning = input<boolean>(false);

  readonly selectItem = output<void>();

  private readonly menuContext = inject(UI_MENU_CONTEXT, { optional: true });

  activate(): void {
    if (this.disabled()) {
      return;
    }
    this.selectItem.emit();
    this.menuContext?.close();
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.activate();
    }
  }
}
